import * as React from 'react';
import { useAccountPositionsGesRatValSPShortcut } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const AccountsPositionsGesRatValSPShortcut = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionsGesRatValSPShortcut();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
